import './filesSection.scss';

import { State } from 'modules/data';
import { ConnectedProps } from 'modules/react-redux';
import React from 'react';
import bemFactory from 'react-bem-factory';
import { connect } from 'react-redux';

import { removeAttachment } from '../../actions';
import FileList from '../../components/filesSection/FileList/FileList';
import { SectionContainer } from '../../components/SectionContainer';
import { AttachmentKind } from '../../data/AttachmentKind';
import { getContext, getNewAttachments, getRequest, isLoading } from '../../selectors/pageSelectors';
import { RequestEditMode } from '../../selectors/requestSelectors';
import { messages } from './FilesSection.messages';

function mapStateToProps(state: State) {
    return {
        attachments: getRequest(state).attachments,
        context: getContext(state),
        newAttachments: getNewAttachments(state),
        loading: isLoading(state),
    };
}

const mapDispatchToProps = {
    removeAttachment,
};

interface OwnProps {
    editMode?: RequestEditMode;
    className?: string;
    readonly?: boolean;
    maxFilesCount?: number;
    required?: boolean;
}

type Props = ConnectedProps<OwnProps, typeof mapStateToProps, typeof mapDispatchToProps>;

const bem = bemFactory.block('reqf-files-section');

/**
 * @deprecated Use AttachmentsSection
 */
class FilesSection extends React.PureComponent<Props> {
    public render() {
        const {
            className,
            attachments,
            newAttachments,
            removeAttachment,
            readonly,
            editMode,
            maxFilesCount,
            required,
        } = this.props;

        if (readonly && attachments.length === 0) {
            return null;
        }

        return (
            <SectionContainer className={bem.add(className)()} required={required} title={messages.sectionName}>
                <div className={bem('content')}>
                    <FileList
                        attachments={attachments}
                        newAttachments={newAttachments}
                        removeAttachment={removeAttachment}
                        readonly={readonly}
                        attachmentKind={AttachmentKind.General}
                        editMode={editMode}
                        maxFilesCount={maxFilesCount}
                    />
                </div>
            </SectionContainer>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FilesSection);
